import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RestclientService } from '../../../services/restclient/restclient.service';
import { TypAction, TypificationdatashareService } from '../typificationdatashare.service';
import { TypimagesService } from '../typimages.service';
import { Vehicle } from 'src/app/models/wdtk-event.model';

@Component({
  selector: 'app-container-typification',
  templateUrl: './container-typification.component.html',
  styleUrls: ['../typification.component.css'],
})
export class ContainerTypificationComponent implements OnInit {
  public eventID: string;
  public eventImage: string;
  public vehicleBunde: Vehicle[];
  public selectedVehicle: number = 1;
  public vehicleIndex: number = 1;
  public selectedBundle: number = 1;
  public bundleIndex: number = 0;
  public systemTypConfig;
  public truckClassification;

  forcePlate: boolean = false;
  plateConfirmed: boolean = false;

  //@ViewChild('myCanvas', {static: false}) myCanvas: ElementRef;

  @ViewChild('myCanvas', { static: true })
  public canvas: ElementRef<HTMLCanvasElement>;

  constructor(
    public activeModal: NgbActiveModal,
    private typshareservice: TypificationdatashareService,
    private typImageService: TypimagesService
  ) { }

  ngOnInit(): void {
    this.typshareservice._eventID$.subscribe((value) => {
      this.eventID = value;
    });
    this.typshareservice._eventImage$.subscribe((value) => {
      this.eventImage = value;
    });
    this.typshareservice._vehicleBunde$.subscribe((value) => {
      this.vehicleBunde = value.modifiedTyp;
      this.typTruck(value.modifiedTyp);
      switch(value.action){
        case TypAction.NEW_VEHICLE:
          console.log("NEW_VEHICLE", Number(this.vehicleBunde[this.vehicleBunde.length - 1].order)-1);
          this.vehicleSelected(Number(this.vehicleBunde[this.vehicleBunde.length - 1].order)-1);
          break;
        case TypAction.NEW_BUNDLE:
          this.bundleSelected(Number(this.vehicleBunde[this.selectedVehicle].elements.element[this.vehicleBunde[this.selectedVehicle].elements.element.length -1]));
          break;
        }
    });
    this.typshareservice._systemTypConfig$.subscribe((value) => {
      this.systemTypConfig = value;
    });
  }

  newVehicle() {
    this.typshareservice.newVehicle();

  }

  vehicleSelected(vehiclesID) {
    this.selectedVehicle = vehiclesID;
    for (let i = 0; i < this.vehicleBunde.length; i++) {
      if (Number(this.vehicleBunde[i].order) == (Number(this.selectedVehicle) + 1)) {
        this.vehicleIndex = i;
        break;
      }
    }
    this.selectedBundle = 1;
    this.bundleIndex = 0;

    if(this.typshareservice.getVehiclePlateByOrder(Number(this.selectedVehicle) + 1) === ""){
      this.forcePlate = true;
    }

  }

  craneChange(vehicleIndx) {
    //this.vehicleBunde[vehicleIndx].crane = !this.vehicleBunde[vehicleIndx].crane;
    for (let param of this.vehicleBunde[vehicleIndx].params.param) {
      if (param.name == 'craneDetection') {
        if (param.value == 'TRUE') {
          param.value = 'FALSE';
        }
        if (param.value == 'FALSE') {
          param.value = 'TRUE';
        }
      }
    }
  }

  bundleSelected(bundleID) {
    this.selectedBundle = bundleID;
    for (let i = 0; i < this.vehicleBunde[this.vehicleIndex].elements.element.length; i++) {
      if (Number(this.vehicleBunde[this.vehicleIndex].elements.element[i].id) == Number(this.selectedBundle)) {
        this.bundleIndex = i;
        break;
      }
    }
  }

  bundleArrangementSelected(event: Event) {
    //this.vehicleBunde[this.vehicleIndex].bundles[this.bundleIndex].arrangement = arrangement;
    /*for (let param of this.vehicleBunde[this.vehicleIndex].bundles[this.bundleIndex ].params) {
      if (param.name == 'arrange') {
        param.value = arrangement;
      }
    }*/
    const selectedValue = (event.target as HTMLSelectElement).value;

    let bundle = this.vehicleBunde[this.vehicleIndex].elements.element[this.bundleIndex];
    for (let param of bundle.params.param) {
      if (param.name == 'arrange') {
        param.value = selectedValue;
        break;
      }
    }

    this.typTruck(this.vehicleBunde);
  }

  newBundle() {
    this.typshareservice.newBundle(this.vehicleIndex);
  }

  deleteVehicle() {
    this.typshareservice.deleteVehicle(this.vehicleIndex);
    //this.vehicleIndex = this.vehicleIndex - 1;
    //this.selectedVehicle = this.selectedVehicle - 1;
    this.selectedVehicle = 1;
    this.vehicleIndex = 1;
    this.selectedBundle = 1;
    this.bundleIndex = 0;
  }

  deleteBundle() {
    // reindexsar elementos restantes...
    this.typshareservice.deleteBundle(this.vehicleIndex, this.bundleIndex);
    //this.selectedBundle = this.selectedBundle - 1;
    //this.bundleIndex = this.selectedBundle - 1;
    this.selectedBundle = 1;
    this.bundleIndex = 0;

  }

  resetTyp() {
    this.selectedVehicle = 1;
    this.vehicleIndex = 1;
    this.selectedBundle = 1;
    this.bundleIndex = 0;
    this.typshareservice.resetTyp();
  }

  saveTyp() {
    //this.typshareservice.saveTyp(this.plate, this.vehicleBunde);
    this.activeModal.close(this.typshareservice.saveTyp(this.vehicleBunde));
  }

  drawTheTruck() {
    const img = new Image();
    const ctx = this.canvas.nativeElement.getContext('2d');
    //const ctx = document.getElementById("canvas").getContext("2d");
    img.addEventListener(
      'load',
      () => {
        // execute drawImage statements here
        ctx.drawImage(img, 0, 0, 50, 100);
        ctx.beginPath();
        //ctx.moveTo(30, 96);
        //ctx.lineTo(70, 66);
        //ctx.lineTo(103, 76);
        //ctx.lineTo(170, 15);
        ctx.stroke();
      },
      false
    );
    img.src = './../../../assets/typification/trailers/cabin.png';
  }

  typTruck(typification: Vehicle[]) {
    //console.log(typification);
    const ctx = this.canvas.nativeElement.getContext('2d');
    ctx.canvas.width = 1800;
    //ctx.canvas.height = 225;

    let destY = 12;

    let factor = 0.9;

    let fixedCabinWidth = 125 * factor;
    let fixedCabinHeight = 125 * factor;

    let fixedPlatformWidth = 325 * factor;
    let fixedPlatformHeight = 120 * factor;



    for (let data of typification) {
      if (data.type === 'cabin') {
        ctx.drawImage(
          this.typImageService.getImage('cabin').oImage,
          0,
          destY,
          fixedCabinWidth,
          fixedCabinHeight
        );
        //ctx.drawImage(this.typImageService.getImage('cabin').oImage, 0, 0, this.typImageService.getImage('cabin').oImage.width, this.typImageService.getImage('cabin').oImage.height,0,0,50,100);
      }
      if (data.type === 'trailer') {
        let trailerXInitialValue =
          fixedCabinWidth + (Number(data.order) - 2) * fixedPlatformWidth;
        ctx.drawImage(
          this.typImageService.getImage('trailerPlataform').oImage,
          trailerXInitialValue,
          destY + 5,
          fixedPlatformWidth,
          fixedPlatformHeight
        );
        //ctx.drawImage(this.typImageService.getImage('trailerPlataform').oImage, 0, 0, this.typImageService.getImage('trailerPlataform').oImage.width, this.typImageService.getImage('trailerPlataform').oImage.height,actualx, 0, 150, 100);

        //let fixedBundleWidth = 100 * factor;
        let fixedBundleHeight = 100 * factor;


        let fixedBundleWidth = fixedPlatformWidth / data.elements.element.length;


        for (let bundle of data.elements.element) {
          for (let param of bundle.params.param) {
            if (param.name === 'arrange') {
              if (param.value === 'chips') {
                //let baseX = 50;
                //let actualx = baseX * Number(bundle.id);
                //ctx.drawImage(this.typImageService.getImage('longitudinal3').oImage, actualx, 15, 50, 50);
                let bundleXInitialValue =
                  trailerXInitialValue +
                  (Number(bundle.id) - 1) * fixedBundleWidth;
                ctx.drawImage(
                  this.typImageService.getImage('chipContainer').oImage,
                  bundleXInitialValue,
                  destY - 20,
                  fixedBundleWidth,
                  fixedBundleHeight
                );
              }
            }
          }
        }
      }
    }
  }

  confirmPlate() {

    const plate = this.vehicleBunde[this.vehicleIndex].id;

    if (!plate || plate.trim() === '') return;

    this.forcePlate = false;
    this.plateConfirmed = true;
  }


  get isBlocked(): boolean {
    return this.forcePlate && !this.plateConfirmed;
  }


  
onPlateChange(newPlate: string) {

  // actualizar directamente el objeto actual (ya está referenciado)
  this.vehicleBunde[this.vehicleIndex].id = newPlate;

  // emitir cambio hacia el service
  this.typshareservice.updateVehicleBundle(this.vehicleBunde);

}



}
